import React, { useState } from 'react'
import {Grid, Stack, CircularProgress, Modal, Box, Typography} from '@mui/material'
import WbButton from '../../components/common/WbButton';
import { angryEmoji, annoyedEmoji, calmEmoji, confusedEmoji, excitedEmoji, focusedEmoji, happyEmoji, hurtEmoji, ragingEmoji, sadEmoji, sickEmoji, sillyEmoji, surprisedEmoji, terrifiedEmoji, tiredEmoji, worriedEmoji } from '../../components/assets/images'
import { useNavigate  } from 'react-router-dom';
import paths from '../../routes/paths'
import { safeSpaceApi } from '../../services/api/safespace/safeSpaceApi';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export default function Zone() {
    const navigate = useNavigate();

      // Read from localStorage and get config messages
    const safeSpaceConfig = JSON.parse(localStorage.getItem('safeSpaceConfig'));
    const outOfHoursMessage = safeSpaceConfig?.messages?.find(msg => msg.messageType === 1);

    const [loading, setLoading] = useState(false);
    const [showSuccessPopup, setShowSuccessPopup] = useState(false);
    const pupilData = JSON.parse(localStorage.getItem('pupil') || '{}');
    const staffData = JSON.parse(localStorage.getItem('selectedStaff') || '{}');
    const [selectedZone, setSelectedZone] = useState(''); // Add state for selected zone

    // Get specific properties with null checks

    const outOfHoursMessageContent = outOfHoursMessage?.messageContent;
    const isoutOfHoursEnabled = outOfHoursMessage?.isEnabled;
    const outOfHoursStartTime = outOfHoursMessage?.outOfHoursStartTime;
    const outOfHoursEndTime = outOfHoursMessage?.outOfHoursEndTime;
    
    // Auto response message for the success popup
    const autoResponceMessage = safeSpaceConfig?.messages?.find(msg => msg.messageType === 0);
    const autoResponceMessageContent = autoResponceMessage?.messageContent;

     // Helper to check if current time is within out-of-hours
    function isWithinOutOfHours() {
        if (!isoutOfHoursEnabled || !outOfHoursStartTime || !outOfHoursEndTime) return false;
        const now = new Date();
        const [startHour, startMinute] = outOfHoursStartTime.split(':').map(Number);
        const [endHour, endMinute] = outOfHoursEndTime.split(':').map(Number);
        const start = new Date(now);
        start.setHours(startHour, startMinute, 0, 0);
        const end = new Date(now);
        end.setHours(endHour, endMinute, 0, 0);
        if (end < start) {
        // Overnight range
        if (now >= start) return true;
        if (now <= end) return true;
        return false;
        }
        return now >= start && now <= end;
    }

    const handleZoneClick = (zoneName) => {
        setSelectedZone(zoneName);
        localStorage.setItem('selectedZone', zoneName);
    };    

    // Add this function before the return statement
    const getEmotionByZone = (zone) => {
        const emotions = {
            'blue': 'sad',
            'green': 'happy',
            'orange': 'surprised',
            'red': 'angry'
        };
        return emotions[zone] || '';
    };

    // Add this function to get zone-specific button styles
    const getZoneButtonStyle = (zoneName) => {
        const styles = {
           'blue': {background: 'linear-gradient(to bottom,rgb(36, 190, 224) 0%, rgb(13, 84, 128) 100%)', backgroundColor: '#1976D2 !Important', color: '#fff' },
           'green': {background: 'linear-gradient(to bottom,rgb(145, 208, 77) 0%, rgb(0, 115, 50) 100%)', backgroundColor: '#2E7D32 !Important', color: '#fff' },
           'orange': {background: 'linear-gradient(to bottom, rgb(254, 194, 2) 0%, rgb(205, 117, 0) 100%)', backgroundColor: '#ED6C02 !Important', color: '#fff' },
           'red': { background: 'linear-gradient(to bottom,rgb(251, 2, 0) 0%, rgb(185, 0, 12) 100%)', backgroundColor: '#D32F2F !Important', color: '#fff' }
        };
        return styles[zoneName] || {};
    };

    const handleSubmit = async () => {
        try {
            //debugger;
          setLoading(true);
          
          // Get current date in ISO format
          const currentDate = new Date().toISOString();
          const conversationData = {
            studentId: pupilData.studentId,
            SchoolId: pupilData.schoolId,
            responderId: staffData.responderId,
            conversationTitle: 'How are you feeling?',
            conversationStartMessage: `I am in a ${getEmotionByZone(selectedZone)} zone today.`,
            zone: selectedZone,
            hearBackType: 'MESSAGE',
            isNameAnonymous: true,
            isSafeGuarded: false,
            isEscalated: false,
            escalatedToStaffId: '',
            isTransfered: false,
            transferedToStaffId: 0,
            sevirity: '',
            conversationTypeId: 0,
            isFollowUpInPerson: false,
            conversationStartDate: currentDate,
            conversationEndDate: currentDate,
            conversationModifiedDate: currentDate,
            isConversationClosed: false,
            isConversationArchived: false
            //attachments: formData.attachedFile ? [formData.attachedFile] : []
          };

          // Store the selected zone in localStorage for the success message
          localStorage.setItem('selectedZone', selectedZone);
          
          // The request goes first.
          //
          // The success toast and the popup used to fire before it was even sent, and the
          // loader was switched off with them - so a child was told their message had been
          // recorded while it was still in flight, and told the same thing if it failed.
          // On a safeguarding tool that is the worst thing this screen can do.
          const response = await safeSpaceApi.submitSafeSpaceConversation({
            conversation: conversationData
          });

          setLoading(false);
          toast.success('Conversation started successfully!', {
          position: "top-right",
          autoClose: 2000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
        });
          setShowSuccessPopup(true);
                                  
        } catch (error) {
          setLoading(false);
            toast.error('Failed to submit conversation', {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
              });
          console.error('Failed to submit conversation:', error);
        }
      };
  return (
    <>
        <Grid container columnSpacing={3} rowSpacing={{ xs: 2, sm: 2, md: 0 }}>
        {/* Floating Out-of-Hours Message */}
        {isoutOfHoursEnabled && isWithinOutOfHours() && (
          <div style={{
            position: 'fixed',
            top: 100,
            right: 20,
            zIndex: 9999,
            background: '#fff3cd',
            color: '#856404',
            border: '1px solid #ffeeba',
            borderRadius: 8,
            padding: '16px 24px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.12)',
            minWidth: 320,
            maxWidth: 400
          }}>
            <div style={{fontWeight: 600, marginBottom: 4}}>Out of Hours</div>
            <div>{outOfHoursMessageContent
                ? outOfHoursMessageContent
                    .replace(/\[Adult Name\]/gi, staffData.staffName || '')
                    .replace(/\[From\]/gi, outOfHoursStartTime || '')
                    .replace(/\[To\]/gi, outOfHoursEndTime || '')
                : ''
                }</div>
            {/* <div style={{marginTop: 8, fontSize: 13, color: '#856404'}}>
              From {outOfHoursStartTime} to {outOfHoursEndTime}
            </div> */}
          </div>
        )}
            {loading===true? (
                <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '500px' }}>
                <CircularProgress />
                </div>  
                ) : (  
                <>
                    <Grid item lg={3} md={4} sm={6} xs={12}>
                        <div className='blue-zone zones'>
                            <div className={`blue-emojis zone ${selectedZone === 'blue' ? 'selected' : ''}`}
                                    onClick={() => handleZoneClick('blue')}
                                    style={{ opacity: selectedZone && selectedZone !== 'blue' ? 0.5 : 1 }}>
                                <div className="emojis">
                                    <img src={sadEmoji} alt="" />
                                    <span>Sad</span>
                                </div>
                                <div className="emojis">
                                    <img src={hurtEmoji} alt="" />
                                    <span>Hurt</span>
                                </div>
                                <div className="emojis">
                                    <img src={sickEmoji} alt="" />
                                    <span>Sick</span>
                                </div>
                                <div className="emojis">
                                    <img src={tiredEmoji} alt="" />
                                    <span>Tired</span>
                                </div>
                            </div>
                            <h2>Blue Zone</h2>
                            {selectedZone === 'blue' && (
                                <WbButton 
                                    CustomButtonText={'Let ' + staffData.staffName + ' Know'}
                                    style={getZoneButtonStyle('blue')}
                                    onClick={handleSubmit} 
                                />
                            )}
                        </div>
                    </Grid>
                    <Grid item lg={3} md={4} sm={6} xs={12}>
                        <div className='zones green-zone'>
                            <div className={`green-emojis zone ${selectedZone === 'green' ? 'selected' : ''}`}
                                    onClick={() => handleZoneClick('green')}
                                    style={{ opacity: selectedZone && selectedZone !== 'green' ? 0.5 : 1 }}>
                                <div className="emojis">
                                    <img src={happyEmoji} alt="" />
                                    <span>Happy</span>
                                </div>
                                <div className="emojis">
                                    <img src={focusedEmoji} alt="" />
                                    <span>Focused</span>
                                </div>
                                <div className="emojis">
                                    <img src={calmEmoji} alt="" />
                                    <span>Calm</span>
                                </div>
                                <div className="emojis">
                                    <img src={excitedEmoji} alt="" />
                                    <span>Excited</span>
                                </div>
                            </div>
                            <h2>Green Zone</h2>
                            {selectedZone === 'green' && (
                                <WbButton 
                                    CustomButtonText={'Let ' + staffData.staffName + ' Know'}
                                    style={getZoneButtonStyle('green')}
                                    onClick={handleSubmit} 
                                />
                            )}
                        </div>
                    </Grid>
                    <Grid item lg={3} md={4} sm={6} xs={12}>
                        <div className='zones orange-zone'>
                            <div className={`orange-emojis zone ${selectedZone === 'orange' ? 'selected' : ''}`}
                                    onClick={() => handleZoneClick('orange')}
                                    style={{ opacity: selectedZone && selectedZone !== 'orange' ? 0.5 : 1 }}>
                                <div className="emojis">
                                    <img src={surprisedEmoji} alt="" />
                                    <span>Surprised</span>
                                </div>
                                <div className="emojis">
                                    <img src={confusedEmoji} alt="" />
                                    <span>Confuse</span>
                                </div>
                                <div className="emojis">
                                    <img src={worriedEmoji} alt="" />
                                    <span>Worried</span>
                                </div>
                                <div className="emojis">
                                    <img src={sillyEmoji} alt="" />
                                    <span>Silly</span>
                                </div>
                            </div>
                            <h2>Orange Zone</h2>
                            {selectedZone === 'orange' && (
                                <WbButton 
                                    CustomButtonText={'Let ' + staffData.staffName + ' Know'}
                                    style={getZoneButtonStyle('orange')}
                                    onClick={handleSubmit} 
                                />
                            )}
                        </div>
                    </Grid>
                    <Grid item lg={3} md={4} sm={6} xs={12}>
                        <div className='zones red-zone'>
                            <div className={`red-emojis zone ${selectedZone === 'red' ? 'selected' : ''}`}
                                    onClick={() => handleZoneClick('red')}
                                    style={{ opacity: selectedZone && selectedZone !== 'red' ? 0.5 : 1 }}>
                                <div className="emojis">
                                    <img src={angryEmoji} alt="" />
                                    <span>Angry</span>
                                </div>
                                <div className="emojis">
                                    <img src={ragingEmoji} alt="" />
                                    <span>Raging</span>
                                </div>
                                <div className="emojis">
                                    <img src={terrifiedEmoji} alt="" />
                                    <span>Terrified</span>
                                </div>
                                <div className="emojis">
                                    <img src={annoyedEmoji} alt="" />
                                    <span>Annoyed</span>
                                </div>
                            </div>
                            <h2>Red Zone</h2>
                            {selectedZone === 'red' && (
                                <WbButton 
                                    CustomButtonText={'Let ' + staffData.staffName + ' Know'}
                                    style={getZoneButtonStyle('red')}
                                    onClick={handleSubmit} 
                                />
                            )}
                        </div>
                    </Grid>
                </>
            )}  
        </Grid>
        
        {/* Success Popup Modal */}
        <Modal
            open={showSuccessPopup}
            aria-labelledby="success-modal"
            aria-describedby="conversation-success"
            sx={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                backgroundColor: 'rgba(255, 255, 255, 0.9)'
            }}
        >
            <Box
                sx={{
                    p: 4,
                    bgcolor: 'background.paper',
                    borderRadius: 3,
                    boxShadow: 3,
                    textAlign: 'left',
                    width: '100%',
                    maxWidth: 600,
                    m: 2
                }}
            >
                <Typography variant="h4" gutterBottom>
                    Message Sent!
                </Typography>
                <Typography variant="body1" sx={{ mb: 4 }}>
                    {autoResponceMessageContent && autoResponceMessageContent.trim() !== ''
                        ? autoResponceMessageContent.replace(/\[Adult Name\]/gi, staffData?.staffName || '')
                        : `${staffData?.staffName || ''} knows that you are in the ${selectedZone} zone today and will get back to you soon.`}
                </Typography>
                <Stack direction="row" justifyContent="center">
                    <WbButton
                        CustomButtonText="Home"
                        onClick={() => {
                            setShowSuccessPopup(false);
                            navigate(paths.pupilSurveys);
                        }}
                    />
                </Stack>
            </Box>
        </Modal>     
    </>        
  )
}
